import { SEARCH_STRING_MICROFRONTEND_NAME } from './constants';
import { ESearchStringView } from '../../../../shared/common/services/microfrontends/types';
import { ensureMicrofrontend } from '../../../utils/ensureMicrofrontend';

/** Переключает вид поисковой строки: полноразмерная строка или компактная кнопка. */
export async function setView(view: ESearchStringView): Promise<void> {
  const microfrontend = await ensureMicrofrontend(SEARCH_STRING_MICROFRONTEND_NAME);

  return microfrontend?.call('/v1/set-view', { view });
}
